import React, {useEffect, useState} from 'react'
import { Button, Col, Collapse, Row } from "reactstrap";
import { connect } from "react-redux";


// component
import ModalNewItem from "./tools/ModalNewItem";
import SpaViewComponent from "./views/SpaViewComponent";
import SpecialViewComponent from "./views/SpecialViewComponent";
import TransportViewComponent from "./views/TransportViewComponent";
import AfiViewComponent from "./views/AfiViewComponent";
import HeaderButtonComponent from "./tools/HeaderButtonComponent";
import TotalsIndicator from "./components/TotalsIndicator";

// actions
import { add, search } from "../../redux/actions/todoFluye/wishlistActions";
import { setViewMode } from "../../redux/actions/generalActions/mainActions";
import { setForm, setItem } from "../../redux/actions/generalActions/formActions";
import { setFilter, setTableParams } from "../../redux/actions/generalActions/listActions";

// utils
import { wishlistTypes} from "../../util/WishlistUtils";
import { LB_WL_ADD_REQUEST } from "../i18n/i18n";
import RestaurantViewComponent from "./views/RestaurantViewComponent";
import ActivityViewComponent from "./views/ActivityViewComponent";
import {TT_DELETE} from "../i18n/toolTips";
import {CustomIconButton, GenericTableButton, hasPermission} from "../buttons/buttonsActions";
import {ConfirmDelete} from "../confirmAlert/ConfirmDelete";
import {genericActions} from "../../redux/actions/generics/GenericActions";
import {placeService} from "../../jwt/_services/hotel/placeService";
import {wishlistService} from "../../jwt/_services/todoFluye/wishlistService";

const WishlistCardContainer = props => {
    const {wishList} = props
    const fbDataBaseId = props.mainState?.app?.fbDataBase?.id

    const originalComponents = wishList?.components
    const [componentsToShow, setComponentsToShow] = useState(wishList?.components)
    const [filter, setFilter] = useState(null);
    const [collapse, setCollapse] = useState(false);
    const [modal, setModal] = useState(false);

    useEffect(() => {
        onSelectFilter()
    }, [originalComponents]);

    const handleToggleModal = () => setModal(!modal);
    const handleCollapse = () => setCollapse( !collapse );
   const onSelectFilter = selectedFilter => {
       if(filter == selectedFilter){
           setFilter(null)
           setComponentsToShow( originalComponents )
           return
       }

       const newComponentesToShow = wishList.components.filter( component => {
           if(component.status == selectedFilter)
               return component
       })

       setFilter(selectedFilter)
       setComponentsToShow(newComponentesToShow)
   }

    const confirmDelete = data => ConfirmDelete({
        data,
        fbDataBaseId,
        service: wishlistService,
        remove : genericActions.remove ,
    });

    return <>
        <div className={'wl-list-container ptb-1em'}>
            {
                hasPermission('delete') && <Row>
                    <Col>
                        <div className={'float-right'}>
                            <CustomIconButton
                                icon={'fa fa-times'}
                                permission={'delete'}
                                clazz={'text-danger btn-del-wl'}
                                onClick={() => confirmDelete(wishList)}
                            />
                        </div>
                    </Col>
                </Row>
            }
            <Row>
                <Col className={'fex-center'}>
                    {wishList?.reservationNumber}
                </Col>
                <Col className={'wl-guest-info'}>
                    <label>{wishList?.visitor?.name}</label>
                    <label className={'link'}>{wishList?.visitor?.email}</label>
                </Col>
                <Col className={'fex-center'}>{wishList?.totalServices}</Col>
                <Col className={'fex-center'}>
                    <TotalsIndicator
                        value={wishList?.confirmedServices}
                        style={'wl-item-confirmed'}
                        onSelectFilter={()=>onSelectFilter('CONFIRMED')}
                    />
                </Col>
                <Col className={'fex-center'}>
                    <TotalsIndicator
                        value={wishList?.processingServices}
                        style={'wl-item-processing'}
                        onSelectFilter={()=>onSelectFilter('PROCESSING')}
                    />
                </Col>
                <Col className={'fex-center'}>
                    <TotalsIndicator
                        value={wishList?.rejectedServices}
                        style={'wl-item-rejected'}
                        onSelectFilter={()=>onSelectFilter('REJECTED')}
                    />
                </Col>
                <Col className={'fex-center'} sm={1}>
                    <HeaderButtonComponent
                        newItem={wishList?.components?.length === 0}
                        isCollapsed={!collapse}
                        onClick={handleCollapse}
                        handleToggleModal={handleToggleModal}
                    />
                </Col>

            </Row>

            <Collapse isOpen={collapse} className={'mt-2em'}>
                <Row>
                    <Col sm={11}>
                        <div className={'wl-cards-section'}>
                            <div className={'wl-cards-container'}>
                                {
                                    componentsToShow?.map((component, index) => {
                                        switch (component?.type) {
                                            case wishlistTypes.transportation.description:
                                                return <TransportViewComponent
                                                    key={`transport_${index}`}
                                                    wishlist={wishList}
                                                    component={component}
                                                    showModal={handleToggleModal}
                                                />
                                            case wishlistTypes.afi.description:
                                                return <AfiViewComponent
                                                    key={`afi_${index}`}
                                                    component={component}
                                                    wishlist={wishList}
                                                    showModal={handleToggleModal}
                                                />
                                            case wishlistTypes.spa.description:
                                                return <SpaViewComponent
                                                    key={`spa_${index}`}
                                                    component={component}
                                                    wishlist={wishList}
                                                    showModal={handleToggleModal}
                                                />
                                            case wishlistTypes.restaurant.description:
                                                return  <RestaurantViewComponent
                                                    key={`rest_${index}`}
                                                    component={component}
                                                    wishlist={wishList}
                                                    showModal={handleToggleModal}
                                                />
                                            case wishlistTypes.activity.description:
                                                return <ActivityViewComponent
                                                    key={`activity_${index}`}
                                                    wishlist={wishList}
                                                    component={component}
                                                    showModal={handleToggleModal}
                                                />
                                            case wishlistTypes.special.description:
                                                return <SpecialViewComponent
                                                    key={`special_${index}`}
                                                    wishlist={wishList}
                                                    component={component}
                                                    showModal={handleToggleModal}
                                                />
                                            default:
                                                return <></>
                                        }
                                    })
                                }
                            </div>
                        </div>
                    </Col>
                    <Col className={'fex-center'} sm={1}>
                        <div className={'add-item-card'}>
                            <Button className={'link'} color={'link'} type={'button'} onClick={handleToggleModal}>
                                <i className={'fa fa-plus'} aria-hidden="true"/><br/>
                                { LB_WL_ADD_REQUEST }
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Collapse>
        </div>

        <ModalNewItem
            isOpen={modal}
            wishlist={ wishList }
            handleToggle={ handleToggleModal }
        />
    </>
}

const mapStateToProps = state => ({
    mainState: state.mainProps,
    listState : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    search,
    add,
    setTableParams,
    setViewMode,
    setItem, setForm
})

export default connect(mapStateToProps, mapActionsToProps)(WishlistCardContainer)